import React, { Component } from 'react';
import { Title } from 'bulma-react';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';

const style = {
  img: {
    width: '2.5rem',
    height: '2.5rem',
    borderRadius: '3rem',
    backgroundColor: '#888',
    background: 'url()',
    backgroundSize: '2.5rem, cover',
    float: 'left',
    margin: '0 0.5rem 0.5rem 0',
  },
  title: {
    paddingTop: '1.2rem',
    textTransform: 'uppercase',
  },
  name: {
    float: 'left',
    textTransform: 'uppercase',
    margin: 0,
  },
  date: {
    float: 'right',
    margin: 0,
  },
  upload: {
    float: 'right',
    paddingTop: '2px',
    opacity: '0.5',
    margin: '0 0.6rem 0 0',
  },
};

class BlogHeader extends Component {
  render() {
    const { blog, user, onClick } = this.props;
    const date = moment(blog.creationTime).fromNow();
    style.img.background = `url(${user.imageUrl})`;
    return (
      <div className="blog-header" onClick={onClick} style={{
        textAlign: 'left',
      }}>
        <div style={style.img} title={user.name + 'image'} />
        <div style={{ paddingLeft: '3rem' }}>
          <Title is-6 capitalize style={style.name}
          >{user.name}</Title>
          <Title is-6 style={style.date}>{date}</Title>
          {blog._local &&
            <FontAwesome name="cloud-upload" size="" style={style.upload}/>}
          <div>
            <Title is-4 capitalize style={style.title}
            >{blog.title}</Title>
          </div>
        </div>
        {/*
        */}
        <div style={{ clear: 'both' }}/>
      </div>
    );
  }
}

export default BlogHeader;




// WEBPACK FOOTER //
// ./src/components/BlogHeader.js